import * as React from "react";
const SvgFileGenericicon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 49 64", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M49 16.84v42.1c0 2.8-2.27 5.06-5.07 5.06H5.07C2.27 64 0 61.74 0 58.95V5.05C0 2.25 2.27 0 5.07 0H32.1z", style: {
  fill: "#b3b3b3",
  fillRule: "evenodd"
} }), /* @__PURE__ */ React.createElement("path", { d: "M49 15.9V18H35.2c-2.87 0-4.2-2.32-4.2-5.2V0h2.1z", style: {
  fillRule: "evenodd",
  fill: "#d6d6d6"
} }));
export default SvgFileGenericicon;
